import useLogFilters from 'hooks/useLogFilters'
import {
  FilterDateInput,
  FilterTextInput,
} from 'components/common/logFilterInputs'

export const FILTER_FIELD_POS_LOG = 'posLogFilters'

const PosLogFilterForm = () => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_POS_LOG)

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <FilterTextInput
        label="Status"
        value={filters.status || ''}
        onApply={(value) => setField('status', value)}
      />
      <FilterDateInput
        label="Start Date"
        value={filters.startDate || ''}
        onChange={(value) => setField('startDate', value)}
      />
      <FilterDateInput
        label="End Date"
        value={filters.endDate || ''}
        onChange={(value) => setField('endDate', value)}
      />
    </div>
  )
}

export default PosLogFilterForm
